import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./Context/AuthContext";
import { Auth0Provider } from "@auth0/auth0-react";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Auth0Provider
      domain="dev-s0zg15knyhwngszt.us.auth0.com"
      clientId="amRuFnKzGHbTIG9IStM9Lewllyv8oP8w"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
  <AuthContextProvider>
  <BrowserRouter>
  <ChakraProvider>
    <App />
  </ChakraProvider>
  </BrowserRouter>
  </AuthContextProvider>
  </Auth0Provider>
    
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
